// // src/pages/Reports/tables/BajajMappedTable.js
// import React, { useState, useEffect } from "react"
// import { getCombinedTransactionReport } from "../../../helpers/api_helper"

// const BajajMappedTable = ({ filters }) => {
//   const [expandedRows, setExpandedRows] = useState({})
//   const [tableData, setTableData] = useState([])
//   const [loading, setLoading] = useState(true)
//   const [totalRecords, setTotalRecords] = useState(0)
//   const [pageIndex, setPageIndex] = useState(0)
//   const [pageSize, setPageSize] = useState(10)

//   const fetchData = async (
//     newPageIndex = pageIndex,
//     newPageSize = pageSize
//   ) => {
//     setLoading(true)
//     const offset = newPageIndex * newPageSize

//     try {
//       const res = await getCombinedTransactionReport({
//         limit: newPageSize,
//         offset,
//         startDate: filters?.startDate || null,
//         endDate: filters?.endDate || null,
//         mobileNumber:
//           filters?.mobileNumbers?.length > 0 ? filters.mobileNumbers : null,
//       })

//       console.log("Bajaj Mapped API Response:", res)

//       if (!res.success || !res.data) {
//         setTableData([])
//         setTotalRecords(0)
//         return
//       }

//       setTotalRecords(res.totalRecords || 0)

//       let rows = []

//       Object.entries(res.data || {}).forEach(([date, mobiles]) => {
//         Object.entries(mobiles || {}).forEach(([mobile, categories]) => {
//           const openingClosing = categories.opening_closing || {}

//           const bajajRefund = categories.bajaj_refund?.total?.amount || 0
//           const otherRefund = categories.other_refund?.total?.amount || 0
//           const refundedTotal = bajajRefund + otherRefund

//           const bajajRefundDetails = categories.bajaj_refund?.details || []
//           const otherRefundDetails = categories.other_refund?.details || []

//           const subTransactions = [
//             ...bajajRefundDetails.map(detail => ({
//               transactionDateTime: detail.time
//                 ? `${date} ${detail.time}`
//                 : date,
//               transactionId: detail.transaction_id || "N/A",
//               recipient: detail.recipient_name || "Bajaj Finserv",
//               amount: detail.amount || 0,
//               status: "Refunded",
//               refund_txn_id: detail.refund_details?.refund_txn_id || "N/A",
//             })),
//             ...otherRefundDetails.map(detail => ({
//               transactionDateTime: detail.time
//                 ? `${date} ${detail.time}`
//                 : date,
//               transactionId: detail.transaction_id || "N/A",
//               recipient: detail.recipient_name || "Other Vendor",
//               amount: detail.amount || 0,
//               status: "Refunded",
//               refund_txn_id: detail.refund_details?.refund_txn_id || "N/A",
//             })),
//           ]

//           rows.push({
//             id: `${date}-${mobile}`,
//             date: date.trim(),
//             mobile: mobile.trim(),
//             opening: openingClosing.opening || 0,
//             closing: openingClosing.closing || 0,
//             refunded: refundedTotal,
//             subTransactions,
//           })
//         })
//       })

//       rows.sort((a, b) => new Date(b.date) - new Date(a.date))

//       setTableData(rows)
//       setPageIndex(newPageIndex)
//       setPageSize(newPageSize)
//     } catch (err) {
//       console.error("Bajaj Mapped fetch error:", err)
//       setTableData([])
//       setTotalRecords(0)
//     } finally {
//       setLoading(false)
//     }
//   }

//   useEffect(() => {
//     fetchData(0, pageSize)
//   }, [filters, pageSize])

//   const formatCurrency = val => `₹${Number(val || 0).toLocaleString("en-IN")}`

//   const toggleExpand = id => {
//     setExpandedRows(prev => ({ ...prev, [id]: !prev[id] }))
//   }

//   const renderSubTable = (subTransactions = []) => (
//     <div className="bg-light p-4 border-top">
//       <h6 className="mb-3 fw-semibold">Refund & Mapping Details</h6>
//       <div className="table-responsive">
//         <table className="table table-bordered table-sm mb-0">
//           <thead className="table-light">
//             <tr>
//               <th>Transaction Date Time</th>
//               <th>Transaction refund ID</th>
//               <th>Recipient</th>
//               <th>Amount</th>
//               <th>Status</th>
//             </tr>
//           </thead>
//           <tbody>
//             {subTransactions.length > 0 ? (
//               subTransactions.map((sub, idx) => (
//                 <tr key={idx}>
//                   <td>{sub.transactionDateTime || "N/A"}</td>
//                   <td>{sub.refund_txn_id || "N/A"}</td>
//                   <td>{sub.recipient || "N/A"}</td>
//                   <td>{formatCurrency(sub.amount)}</td>
//                   <td>
//                     <span className="badge bg-soft-success text-success">
//                       {sub.status}
//                     </span>
//                   </td>
//                 </tr>
//               ))
//             ) : (
//               <tr>
//                 <td colSpan={5} className="text-center text-muted py-3">
//                   No mapping/refund details found
//                 </td>
//               </tr>
//             )}
//           </tbody>
//         </table>
//       </div>
//     </div>
//   )

//   // ────────────── Export CSV with Main + Sub-transactions ──────────────
//   const handleExportCSV = () => {
//     if (loading || tableData.length === 0) {
//       alert("No data available to export right now.")
//       return
//     }

//     const dateStr = new Date().toISOString().split("T")[0]
//     const filename = `bajaj-mapped-report_${dateStr}.csv`

//     const headers = [
//       "Date (Main)",
//       "Mobile",
//       "Opening",
//       "Closing",
//       "Refunded (Total)",
//       "Transaction Date Time",
//       "Transaction refund ID",
//       "Recipient",
//       "Amount",
//       "Status",
//     ]

//     const csvRows = [headers.join(",")]

//     tableData.forEach(row => {
//       if (row.subTransactions.length === 0) {
//         // No sub-transactions → only main row
//         const mainValues = [
//           `"${(row.date || "").replace(/"/g, '""')}"`,
//           `"${(row.mobile || "").replace(/"/g, '""')}"`,
//           row.opening || 0,
//           row.closing || 0,
//           row.refunded || 0,
//           "",
//           "",
//           "",
//           "",
//           "",
//         ]
//         csvRows.push(mainValues.join(","))
//       } else {
//         // Main row repeat for each sub-transaction
//         row.subTransactions.forEach(sub => {
//           const values = [
//             `"${(row.date || "").replace(/"/g, '""')}"`,
//             `"${(row.mobile || "").replace(/"/g, '""')}"`,
//             row.opening || 0,
//             row.closing || 0,
//             row.refunded || 0,
//             `"${(sub.transactionDateTime || "").replace(/"/g, '""')}"`,
//             `"${(sub.refund_txn_id || "").replace(/"/g, '""')}"`,
//             `"${(sub.recipient || "").replace(/"/g, '""')}"`,
//             sub.amount || 0,
//             `"${(sub.status || "").replace(/"/g, '""')}"`,
//           ]
//           csvRows.push(values.join(","))
//         })
//       }

//       // Blank line between different main rows/groups
//       csvRows.push(",")
//     })

//     const csvContent = csvRows.join("\n")

//     const blob = new Blob([csvContent], { type: "text/csv;charset=utf-8;" })
//     const url = URL.createObjectURL(blob)
//     const link = document.createElement("a")
//     link.href = url
//     link.setAttribute("download", filename)
//     document.body.appendChild(link)
//     link.click()
//     document.body.removeChild(link)
//     URL.revokeObjectURL(url)
//   }

//   const totalPages = Math.ceil(totalRecords / pageSize)
//   const canGoPrev = pageIndex > 0
//   const canGoNext = pageIndex < totalPages - 1

//   const getPageNumbers = () => {
//     const pages = []
//     const maxVisible = 5
//     let start = Math.max(0, pageIndex - 2)
//     let end = Math.min(totalPages, start + maxVisible)

//     if (end - start < maxVisible) {
//       start = Math.max(0, end - maxVisible)
//     }

//     for (let i = start; i < end; i++) {
//       pages.push(i)
//     }
//     return pages
//   }

//   return (
//     <div className="table-responsive">
//       {/* Top Controls – Export button add kiya */}
//       <div className="mb-3 d-flex justify-content-between align-items-center flex-wrap gap-3">
//         <input
//           type="text"
//           className="form-control w-50"
//           placeholder="Search Bajaj Mapped..."
//         />
//         <div className="d-flex align-items-center gap-2">
//           <select
//             className="form-select w-auto"
//             value={pageSize}
//             onChange={e => setPageSize(Number(e.target.value))}
//           >
//             <option value={5}>Show 5</option>
//             <option value={10}>Show 10</option>
//             <option value={20}>Show 20</option>
//             <option value={50}>Show 50</option>
//           </select>

//           <button
//             className="btn btn-soft-primary btn-sm"
//             onClick={handleExportCSV}
//             disabled={loading || tableData.length === 0}
//           >
//             <i className="mdi mdi-download me-1"></i> Export CSV
//           </button>
//         </div>
//       </div>

//       {loading ? (
//         <div className="text-center py-5">
//           <div className="spinner-border text-primary" role="status">
//             <span className="visually-hidden">Loading...</span>
//           </div>
//         </div>
//       ) : tableData.length === 0 ? (
//         <div className="text-center py-5 text-muted">
//           <h5>No Bajaj Mapped records found for the selected filters</h5>
//         </div>
//       ) : (
//         <>
//           <table className="table table-bordered table-hover">
//             <thead className="table-light">
//               <tr>
//                 <th style={{ width: "50px" }}></th>
//                 <th>Date</th>
//                 <th>Mobile</th>
//                 <th>Opening</th>
//                 <th>Closing</th>
//                 <th>Refunded</th>
//               </tr>
//             </thead>
//             <tbody>
//               {tableData.map(row => (
//                 <React.Fragment key={row.id}>
//                   <tr>
//                     <td className="text-center">
//                       <button
//                         className="btn btn-sm btn-link p-0 fs-5"
//                         onClick={() => toggleExpand(row.id)}
//                       >
//                         {expandedRows[row.id] ? "▼" : "▶"}
//                       </button>
//                     </td>
//                     <td>{row.date}</td>
//                     <td>{row.mobile}</td>
//                     <td>{formatCurrency(row.opening)}</td>
//                     <td>{formatCurrency(row.closing)}</td>
//                     <td>{formatCurrency(row.refunded)}</td>
//                   </tr>

//                   {expandedRows[row.id] && (
//                     <tr>
//                       <td colSpan={6} className="p-0">
//                         {renderSubTable(row.subTransactions)}
//                       </td>
//                     </tr>
//                   )}
//                 </React.Fragment>
//               ))}
//             </tbody>
//           </table>

//           {/* Pagination */}
//           <div className="mt-3 d-flex justify-content-between align-items-center flex-wrap gap-3">
//             <div className="text-muted">
//               Showing {tableData.length} of {totalRecords} entries
//               {totalRecords > 0 && (
//                 <span className="ms-2">
//                   Page {pageIndex + 1} of {totalPages}
//                 </span>
//               )}
//             </div>

//             <nav>
//               <ul className="pagination pagination-sm mb-0">
//                 <li className={`page-item ${!canGoPrev ? "disabled" : ""}`}>
//                   <button
//                     className="page-link"
//                     onClick={() => canGoPrev && fetchData(pageIndex - 1)}
//                     disabled={!canGoPrev}
//                   >
//                     Previous
//                   </button>
//                 </li>

//                 {getPageNumbers().map(pageNum => (
//                   <li
//                     key={pageNum}
//                     className={`page-item ${
//                       pageIndex === pageNum ? "active" : ""
//                     }`}
//                   >
//                     <button
//                       className="page-link"
//                       onClick={() => fetchData(pageNum)}
//                     >
//                       {pageNum + 1}
//                     </button>
//                   </li>
//                 ))}

//                 <li className={`page-item ${!canGoNext ? "disabled" : ""}`}>
//                   <button
//                     className="page-link"
//                     onClick={() => canGoNext && fetchData(pageIndex + 1)}
//                     disabled={!canGoNext}
//                   >
//                     Next
//                   </button>
//                 </li>
//               </ul>
//             </nav>
//           </div>
//         </>
//       )}
//     </div>
//   )
// }

// export default BajajMappedTable

// // src/pages/Reports/tables/BajajMappedTable.js
// import React, { useState, useEffect, useRef } from "react"
// import { getCombinedTransactionReport } from "../../../helpers/api_helper"

// const BajajMappedTable = ({ filters }) => {
//   const [expandedRows, setExpandedRows] = useState({})
//   const [tableData, setTableData] = useState([])
//   const [loading, setLoading] = useState(true)
//   const [totalRecords, setTotalRecords] = useState(0)
//   const [pageIndex, setPageIndex] = useState(0)
//   const [pageSize, setPageSize] = useState(5) // ← default 5 kar diya

//   // Cache: key = `${pageIndex}-${pageSize}`, value = { rows: [], timestamp }
//   const cache = useRef(new Map())

//   const getCacheKey = (pIndex, pSize) => `${pIndex}-${pSize}`

//   const fetchData = async (
//     newPageIndex = pageIndex,
//     newPageSize = pageSize,
//     forceRefresh = false
//   ) => {
//     const key = getCacheKey(newPageIndex, newPageSize)

//     // Cache hit → turant data show kar do
//     if (!forceRefresh && cache.current.has(key)) {
//       const cached = cache.current.get(key)
//       setTableData(cached.rows)
//       setPageIndex(newPageIndex)
//       setPageSize(newPageSize)
//       setLoading(false)
//       return
//     }

//     setLoading(true)
//     const offset = newPageIndex * newPageSize

//     try {
//       const res = await getCombinedTransactionReport({
//         limit: newPageSize,
//         offset,
//         startDate: filters?.startDate || null,
//         endDate: filters?.endDate || null,
//         mobileNumber:
//           filters?.mobileNumbers?.length > 0 ? filters.mobileNumbers : null,
//       })

//       console.log("Bajaj Mapped API Response:", res)

//       if (!res.success || !res.data) {
//         setTableData([])
//         setTotalRecords(0)
//         cache.current.delete(key)
//         return
//       }

//       setTotalRecords(res.totalRecords || 0)

//       let rows = []

//       Object.entries(res.data || {}).forEach(([date, mobiles]) => {
//         Object.entries(mobiles || {}).forEach(([mobile, categories]) => {
//           const openingClosing = categories.opening_closing || {}

//           const bajajRefund = categories.bajaj_refund?.total?.amount || 0
//           const otherRefund = categories.other_refund?.total?.amount || 0
//           const refundedTotal = bajajRefund + otherRefund

//           const bajajRefundDetails = categories.bajaj_refund?.details || []
//           const otherRefundDetails = categories.other_refund?.details || []

//           const subTransactions = [
//             ...bajajRefundDetails.map(detail => ({
//               transactionDateTime: detail.time
//                 ? `${date} ${detail.time}`
//                 : date,
//               transactionId: detail.transaction_id || "N/A",
//               recipient: detail.recipient_name || "Bajaj Finserv",
//               amount: detail.amount || 0,
//               status: "Refunded",
//               refund_txn_id: detail.refund_details?.refund_txn_id || "N/A",
//             })),
//             ...otherRefundDetails.map(detail => ({
//               transactionDateTime: detail.time
//                 ? `${date} ${detail.time}`
//                 : date,
//               transactionId: detail.transaction_id || "N/A",
//               recipient: detail.recipient_name || "Other Vendor",
//               amount: detail.amount || 0,
//               status: "Refunded",
//               refund_txn_id: detail.refund_details?.refund_txn_id || "N/A",
//             })),
//           ]

//           rows.push({
//             id: `${date}-${mobile}`,
//             date: date.trim(),
//             mobile: mobile.trim(),
//             opening: openingClosing.opening || 0,
//             closing: openingClosing.closing || 0,
//             refunded: refundedTotal,
//             subTransactions,
//           })
//         })
//       })

//       rows.sort((a, b) => new Date(b.date) - new Date(a.date))

//       // Cache mein save kar do
//       cache.current.set(key, { rows, timestamp: Date.now() })

//       setTableData(rows)
//       setPageIndex(newPageIndex)
//       setPageSize(newPageSize)
//     } catch (err) {
//       console.error("Bajaj Mapped fetch error:", err)
//       setTableData([])
//       setTotalRecords(0)
//       cache.current.delete(key)
//     } finally {
//       setLoading(false)
//     }
//   }

//   useEffect(() => {
//     fetchData(0, pageSize)
//   }, [filters, pageSize])

//   const formatCurrency = val => `₹${Number(val || 0).toLocaleString("en-IN")}`

//   const toggleExpand = id => {
//     setExpandedRows(prev => ({ ...prev, [id]: !prev[id] }))
//   }

//   const renderSubTable = (subTransactions = []) => (
//     <div className="bg-light p-4 border-top">
//       <h6 className="mb-3 fw-semibold">Refund & Mapping Details</h6>
//       <div className="table-responsive">
//         <table className="table table-bordered table-sm mb-0">
//           <thead className="table-light">
//             <tr>
//               <th>Transaction Date Time</th>
//               <th>Transaction refund ID</th>
//               <th>Recipient</th>
//               <th>Amount</th>
//               <th>Status</th>
//             </tr>
//           </thead>
//           <tbody>
//             {subTransactions.length > 0 ? (
//               subTransactions.map((sub, idx) => (
//                 <tr key={idx}>
//                   <td>{sub.transactionDateTime || "N/A"}</td>
//                   <td>{sub.refund_txn_id || "N/A"}</td>
//                   <td>{sub.recipient || "N/A"}</td>
//                   <td>{formatCurrency(sub.amount)}</td>
//                   <td>
//                     <span className="badge bg-soft-success text-success">
//                       {sub.status}
//                     </span>
//                   </td>
//                 </tr>
//               ))
//             ) : (
//               <tr>
//                 <td colSpan={5} className="text-center text-muted py-3">
//                   No mapping/refund details found
//                 </td>
//               </tr>
//             )}
//           </tbody>
//         </table>
//       </div>
//     </div>
//   )

//   const handleExportCSV = () => {
//     if (loading || tableData.length === 0) {
//       alert("No data available to export right now.")
//       return
//     }

//     const dateStr = new Date().toISOString().split("T")[0]
//     const filename = `bajaj-mapped-report_${dateStr}.csv`

//     const headers = [
//       "Date (Main)",
//       "Mobile",
//       "Opening",
//       "Closing",
//       "Refunded (Total)",
//       "Transaction Date Time",
//       "Transaction refund ID",
//       "Recipient",
//       "Amount",
//       "Status",
//     ]

//     const csvRows = [headers.join(",")]

//     tableData.forEach(row => {
//       if (row.subTransactions.length === 0) {
//         const mainValues = [
//           `"${(row.date || "").replace(/"/g, '""')}"`,
//           `"${(row.mobile || "").replace(/"/g, '""')}"`,
//           row.opening || 0,
//           row.closing || 0,
//           row.refunded || 0,
//           "",
//           "",
//           "",
//           "",
//           "",
//         ]
//         csvRows.push(mainValues.join(","))
//       } else {
//         row.subTransactions.forEach(sub => {
//           const values = [
//             `"${(row.date || "").replace(/"/g, '""')}"`,
//             `"${(row.mobile || "").replace(/"/g, '""')}"`,
//             row.opening || 0,
//             row.closing || 0,
//             row.refunded || 0,
//             `"${(sub.transactionDateTime || "").replace(/"/g, '""')}"`,
//             `"${(sub.refund_txn_id || "").replace(/"/g, '""')}"`,
//             `"${(sub.recipient || "").replace(/"/g, '""')}"`,
//             sub.amount || 0,
//             `"${(sub.status || "").replace(/"/g, '""')}"`,
//           ]
//           csvRows.push(values.join(","))
//         })
//       }
//       csvRows.push(",")
//     })

//     const csvContent = csvRows.join("\n")

//     const blob = new Blob([csvContent], { type: "text/csv;charset=utf-8;" })
//     const url = URL.createObjectURL(blob)
//     const link = document.createElement("a")
//     link.href = url
//     link.setAttribute("download", filename)
//     document.body.appendChild(link)
//     link.click()
//     document.body.removeChild(link)
//     URL.revokeObjectURL(url)
//   }

//   const totalPages = Math.ceil(totalRecords / pageSize)
//   const canGoPrev = pageIndex > 0
//   const canGoNext = pageIndex < totalPages - 1

//   const getPageNumbers = () => {
//     const pages = []
//     const maxVisible = 5
//     let start = Math.max(0, pageIndex - 2)
//     let end = Math.min(totalPages, start + maxVisible)

//     if (end - start < maxVisible) {
//       start = Math.max(0, end - maxVisible)
//     }

//     for (let i = start; i < end; i++) {
//       pages.push(i)
//     }
//     return pages
//   }

//   return (
//     <div className="table-responsive">
//       <div className="mb-3 d-flex justify-content-between align-items-center flex-wrap gap-3">
//         <input
//           type="text"
//           className="form-control w-50"
//           placeholder="Search Bajaj Mapped..."
//         />
//         <div className="d-flex align-items-center gap-2">
//           <select
//             className="form-select w-auto"
//             value={pageSize}
//             onChange={e => setPageSize(Number(e.target.value))}
//           >
//             <option value={5}>Show 5</option>
//             <option value={10}>Show 10</option>
//             <option value={20}>Show 20</option>
//             <option value={50}>Show 50</option>
//           </select>

//           <button
//             className="btn btn-soft-primary btn-sm"
//             onClick={handleExportCSV}
//             disabled={loading || tableData.length === 0}
//           >
//             <i className="mdi mdi-download me-1"></i> Export CSV
//           </button>
//         </div>
//       </div>

//       {loading ? (
//         <div className="text-center py-5">
//           <div className="spinner-border text-primary" role="status">
//             <span className="visually-hidden">Loading...</span>
//           </div>
//         </div>
//       ) : tableData.length === 0 ? (
//         <div className="text-center py-5 text-muted">
//           <h5>No Bajaj Mapped records found for the selected filters</h5>
//         </div>
//       ) : (
//         <>
//           <table className="table table-bordered table-hover">
//             <thead className="table-light">
//               <tr>
//                 <th style={{ width: "50px" }}></th>
//                 <th>Date</th>
//                 <th>Mobile</th>
//                 <th>Opening</th>
//                 <th>Closing</th>
//                 <th>Refunded</th>
//               </tr>
//             </thead>
//             <tbody>
//               {tableData.map(row => (
//                 <React.Fragment key={row.id}>
//                   <tr>
//                     <td className="text-center">
//                       <button
//                         className="btn btn-sm btn-link p-0 fs-5"
//                         onClick={() => toggleExpand(row.id)}
//                       >
//                         {expandedRows[row.id] ? "▼" : "▶"}
//                       </button>
//                     </td>
//                     <td>{row.date}</td>
//                     <td>{row.mobile}</td>
//                     <td>{formatCurrency(row.opening)}</td>
//                     <td>{formatCurrency(row.closing)}</td>
//                     <td>{formatCurrency(row.refunded)}</td>
//                   </tr>

//                   {expandedRows[row.id] && (
//                     <tr>
//                       <td colSpan={6} className="p-0">
//                         {renderSubTable(row.subTransactions)}
//                       </td>
//                     </tr>
//                   )}
//                 </React.Fragment>
//               ))}
//             </tbody>
//           </table>

//           <div className="mt-3 d-flex justify-content-between align-items-center flex-wrap gap-3">
//             <div className="text-muted">
//               Showing {tableData.length} of {totalRecords} entries
//               {totalRecords > 0 && (
//                 <span className="ms-2">
//                   Page {pageIndex + 1} of {totalPages}
//                 </span>
//               )}
//             </div>

//             <nav>
//               <ul className="pagination pagination-sm mb-0">
//                 <li className={`page-item ${!canGoPrev ? "disabled" : ""}`}>
//                   <button
//                     className="page-link"
//                     onClick={() => canGoPrev && fetchData(pageIndex - 1)}
//                     disabled={!canGoPrev}
//                   >
//                     Previous
//                   </button>
//                 </li>

//                 {getPageNumbers().map(pageNum => (
//                   <li
//                     key={pageNum}
//                     className={`page-item ${
//                       pageIndex === pageNum ? "active" : ""
//                     }`}
//                   >
//                     <button
//                       className="page-link"
//                       onClick={() => fetchData(pageNum)}
//                     >
//                       {pageNum + 1}
//                     </button>
//                   </li>
//                 ))}

//                 <li className={`page-item ${!canGoNext ? "disabled" : ""}`}>
//                   <button
//                     className="page-link"
//                     onClick={() => canGoNext && fetchData(pageIndex + 1)}
//                     disabled={!canGoNext}
//                   >
//                     Next
//                   </button>
//                 </li>
//               </ul>
//             </nav>
//           </div>
//         </>
//       )}
//     </div>
//   )
// }

// export default BajajMappedTable

// src/pages/Reports/tables/BajajMappedTable.js
import React, { useState, useEffect, useRef } from "react"
import { getCombinedTransactionReport } from "../../../helpers/api_helper"

const BajajMappedTable = ({ filters, tabKey, sharedCache }) => {
  const [expandedRows, setExpandedRows] = useState({})
  const [tableData, setTableData] = useState([])
  const [loading, setLoading] = useState(true)
  const [totalRecords, setTotalRecords] = useState(0)
  const [pageIndex, setPageIndex] = useState(0)
  const [pageSize, setPageSize] = useState(5)

  const getCacheKey = (pIndex, pSize) => `${tabKey}-${pIndex}-${pSize}`

  const fetchData = async (
    newPageIndex = pageIndex,
    newPageSize = pageSize,
    forceRefresh = false
  ) => {
    const key = getCacheKey(newPageIndex, newPageSize)

    // Cache hit → rows + totalRecords dono wapas set kar do
    if (!forceRefresh && sharedCache.current.has(key)) {
      const cached = sharedCache.current.get(key)
      setTableData(cached.rows)
      setTotalRecords(cached.totalRecords) // ← Yeh line add ki – total count cache se wapas aayega
      setPageIndex(newPageIndex)
      setPageSize(newPageSize)
      setLoading(false)
      return
    }

    setLoading(true)
    const offset = newPageIndex * newPageSize

    try {
      const res = await getCombinedTransactionReport({
        limit: newPageSize,
        offset,
        startDate: filters?.startDate || null,
        endDate: filters?.endDate || null,
        mobileNumber:
          filters?.mobileNumbers?.length > 0 ? filters.mobileNumbers : null,
      })

      console.log("Bajaj Mapped API Response:", res)

      if (!res.success || !res.data) {
        setTableData([])
        setTotalRecords(0)
        sharedCache.current.delete(key)
        return
      }

      const currentTotal = res.totalRecords || 0
      setTotalRecords(currentTotal)

      let rows = []

      Object.entries(res.data || {}).forEach(([date, mobiles]) => {
        Object.entries(mobiles || {}).forEach(([mobile, categories]) => {
          const openingClosing = categories.opening_closing || {}

          const bajajRefund = categories.bajaj_refund?.total?.amount || 0
          const otherRefund = categories.other_refund?.total?.amount || 0
          const refundedTotal = bajajRefund + otherRefund

          const bajajRefundDetails = categories.bajaj_refund?.details || []
          const otherRefundDetails = categories.other_refund?.details || []

          const subTransactions = [
            ...bajajRefundDetails.map(detail => ({
              transactionDateTime: detail.time
                ? `${date} ${detail.time}`
                : date,
              transactionId: detail.transaction_id || "N/A",
              recipient: detail.recipient_name || "Bajaj Finserv",
              amount: detail.amount || 0,
              status: "Refunded",
              refund_txn_id: detail.refund_details?.refund_txn_id || "N/A",
            })),
            ...otherRefundDetails.map(detail => ({
              transactionDateTime: detail.time
                ? `${date} ${detail.time}`
                : date,
              transactionId: detail.transaction_id || "N/A",
              recipient: detail.recipient_name || "Other Vendor",
              amount: detail.amount || 0,
              status: "Refunded",
              refund_txn_id: detail.refund_details?.refund_txn_id || "N/A",
            })),
          ]

          rows.push({
            id: `${date}-${mobile}`,
            date: date.trim(),
            mobile: mobile.trim(),
            opening: openingClosing.opening || 0,
            closing: openingClosing.closing || 0,
            refunded: refundedTotal,
            subTransactions,
          })
        })
      })

      rows.sort((a, b) => new Date(b.date) - new Date(a.date))

      // Cache mein rows ke saath totalRecords bhi save kar rahe hain
      sharedCache.current.set(key, {
        rows,
        totalRecords: currentTotal,
        timestamp: Date.now(),
      })

      setTableData(rows)
      setPageIndex(newPageIndex)
      setPageSize(newPageSize)
    } catch (err) {
      console.error("Bajaj Mapped fetch error:", err)
      setTableData([])
      setTotalRecords(0)
      sharedCache.current.delete(key)
    } finally {
      setLoading(false)
    }
  }

  useEffect(() => {
    fetchData(0, pageSize)
  }, [filters, pageSize])

  const formatCurrency = val => `₹${Number(val || 0).toLocaleString("en-IN")}`

  const toggleExpand = id => {
    setExpandedRows(prev => ({ ...prev, [id]: !prev[id] }))
  }

  const renderSubTable = (subTransactions = []) => (
    <div className="bg-light p-4 border-top">
      <h6 className="mb-3 fw-semibold">Refund & Mapping Details</h6>
      <div className="table-responsive">
        <table className="table table-bordered table-sm mb-0">
          <thead className="table-light">
            <tr>
              <th>Transaction Date Time</th>
              <th>Transaction refund ID</th>
              <th>Recipient</th>
              <th>Amount</th>
              <th>Status</th>
            </tr>
          </thead>
          <tbody>
            {subTransactions.length > 0 ? (
              subTransactions.map((sub, idx) => (
                <tr key={idx}>
                  <td>{sub.transactionDateTime || "N/A"}</td>
                  <td>{sub.refund_txn_id || "N/A"}</td>
                  <td>{sub.recipient || "N/A"}</td>
                  <td>{formatCurrency(sub.amount)}</td>
                  <td>
                    <span className="badge bg-soft-success text-success">
                      {sub.status}
                    </span>
                  </td>
                </tr>
              ))
            ) : (
              <tr>
                <td colSpan={5} className="text-center text-muted py-3">
                  No mapping/refund details found
                </td>
              </tr>
            )}
          </tbody>
        </table>
      </div>
    </div>
  )

  const handleExportCSV = () => {
    if (loading || tableData.length === 0) {
      alert("No data available to export right now.")
      return
    }

    const dateStr = new Date().toISOString().split("T")[0]
    const filename = `bajaj-mapped-report_${dateStr}.csv`

    const headers = [
      "Date (Main)",
      "Mobile",
      "Opening",
      "Closing",
      "Refunded (Total)",
      "Transaction Date Time",
      "Transaction refund ID",
      "Recipient",
      "Amount",
      "Status",
    ]

    const csvRows = [headers.join(",")]

    tableData.forEach(row => {
      if (row.subTransactions.length === 0) {
        const mainValues = [
          `"${(row.date || "").replace(/"/g, '""')}"`,
          `"${(row.mobile || "").replace(/"/g, '""')}"`,
          row.opening || 0,
          row.closing || 0,
          row.refunded || 0,
          "",
          "",
          "",
          "",
          "",
        ]
        csvRows.push(mainValues.join(","))
      } else {
        row.subTransactions.forEach(sub => {
          const values = [
            `"${(row.date || "").replace(/"/g, '""')}"`,
            `"${(row.mobile || "").replace(/"/g, '""')}"`,
            row.opening || 0,
            row.closing || 0,
            row.refunded || 0,
            `"${(sub.transactionDateTime || "").replace(/"/g, '""')}"`,
            `"${(sub.refund_txn_id || "").replace(/"/g, '""')}"`,
            `"${(sub.recipient || "").replace(/"/g, '""')}"`,
            sub.amount || 0,
            `"${(sub.status || "").replace(/"/g, '""')}"`,
          ]
          csvRows.push(values.join(","))
        })
      }
      csvRows.push(",")
    })

    const csvContent = csvRows.join("\n")

    const blob = new Blob([csvContent], { type: "text/csv;charset=utf-8;" })
    const url = URL.createObjectURL(blob)
    const link = document.createElement("a")
    link.href = url
    link.setAttribute("download", filename)
    document.body.appendChild(link)
    link.click()
    document.body.removeChild(link)
    URL.revokeObjectURL(url)
  }

  const totalPages = Math.ceil(totalRecords / pageSize)
  const canGoPrev = pageIndex > 0
  const canGoNext = pageIndex < totalPages - 1

  const getPageNumbers = () => {
    const pages = []
    const maxVisible = 5
    let start = Math.max(0, pageIndex - 2)
    let end = Math.min(totalPages, start + maxVisible)

    if (end - start < maxVisible) {
      start = Math.max(0, end - maxVisible)
    }

    for (let i = start; i < end; i++) {
      pages.push(i)
    }
    return pages
  }

  return (
    <div className="table-responsive">
      <div className="mb-3 d-flex justify-content-between align-items-center flex-wrap gap-3">
        <input
          type="text"
          className="form-control w-50"
          placeholder="Search Bajaj Mapped..."
        />
        <div className="d-flex align-items-center gap-2">
          <select
            className="form-select w-auto"
            value={pageSize}
            onChange={e => setPageSize(Number(e.target.value))}
          >
            <option value={5}>Show 5</option>
            <option value={10}>Show 10</option>
            <option value={20}>Show 20</option>
            <option value={50}>Show 50</option>
          </select>

          <button
            className="btn btn-soft-primary btn-sm"
            onClick={handleExportCSV}
            disabled={loading || tableData.length === 0}
          >
            <i className="mdi mdi-download me-1"></i> Export CSV
          </button>
        </div>
      </div>

      {loading ? (
        <div className="text-center py-5">
          <div className="spinner-border text-primary" role="status">
            <span className="visually-hidden">Loading...</span>
          </div>
        </div>
      ) : tableData.length === 0 ? (
        <div className="text-center py-5 text-muted">
          <h5>No Bajaj Mapped records found for the selected filters</h5>
        </div>
      ) : (
        <>
          <table className="table table-bordered table-hover">
            <thead className="table-light">
              <tr>
                <th style={{ width: "50px" }}></th>
                <th>Date</th>
                <th>Mobile</th>
                <th>Opening</th>
                <th>Closing</th>
                <th>Refunded</th>
              </tr>
            </thead>
            <tbody>
              {tableData.map(row => (
                <React.Fragment key={row.id}>
                  <tr>
                    <td className="text-center">
                      <button
                        className="btn btn-sm btn-link p-0 fs-5"
                        onClick={() => toggleExpand(row.id)}
                      >
                        {expandedRows[row.id] ? "▼" : "▶"}
                      </button>
                    </td>
                    <td>{row.date}</td>
                    <td>{row.mobile}</td>
                    <td>{formatCurrency(row.opening)}</td>
                    <td>{formatCurrency(row.closing)}</td>
                    <td>{formatCurrency(row.refunded)}</td>
                  </tr>

                  {expandedRows[row.id] && (
                    <tr>
                      <td colSpan={6} className="p-0">
                        {renderSubTable(row.subTransactions)}
                      </td>
                    </tr>
                  )}
                </React.Fragment>
              ))}
            </tbody>
          </table>

          <div className="mt-3 d-flex justify-content-between align-items-center flex-wrap gap-3">
            <div className="text-muted">
              Showing {tableData.length} of {totalRecords} entries
              {totalRecords > 0 && (
                <span className="ms-2">
                  Page {pageIndex + 1} of {totalPages}
                </span>
              )}
            </div>

            <nav>
              <ul className="pagination pagination-sm mb-0">
                <li className={`page-item ${!canGoPrev ? "disabled" : ""}`}>
                  <button
                    className="page-link"
                    onClick={() => canGoPrev && fetchData(pageIndex - 1)}
                    disabled={!canGoPrev}
                  >
                    Previous
                  </button>
                </li>

                {getPageNumbers().map(pageNum => (
                  <li
                    key={pageNum}
                    className={`page-item ${
                      pageIndex === pageNum ? "active" : ""
                    }`}
                  >
                    <button
                      className="page-link"
                      onClick={() => fetchData(pageNum)}
                    >
                      {pageNum + 1}
                    </button>
                  </li>
                ))}

                <li className={`page-item ${!canGoNext ? "disabled" : ""}`}>
                  <button
                    className="page-link"
                    onClick={() => canGoNext && fetchData(pageIndex + 1)}
                    disabled={!canGoNext}
                  >
                    Next
                  </button>
                </li>
              </ul>
            </nav>
          </div>
        </>
      )}
    </div>
  )
}

export default BajajMappedTable
